import React, {forwardRef, useEffect, useState} from 'react';
import {connect} from "react-redux";

import {AccessRights} from "../../../schemas/accessRightsModel";
import {getJobEditIframeUrl} from "../getJobIframeUrl";
import {listenToDashboardMessaging} from "./jobIframeMessaging";
import {setJobEditPopupIframeLoading} from "./jobEditActions";

const JobEditIframe = forwardRef((props, ref) => {

  const {job, auth, asCustomer, AR, language, dispatch, intl} = props;

  const [iframeUrl, setIframeUrl] = useState("");

  const setListener = (event) => {
    listenToDashboardMessaging(event, dispatch, job, intl);
  }

  const useEffectLoad = async () => {
    dispatch(setJobEditPopupIframeLoading(true));
    const currentIframeUrl = await getJobEditIframeUrl(job, asCustomer, auth, AR, language);
    setIframeUrl(currentIframeUrl + "&dashboardMessaging=true");
    window.addEventListener("message", setListener);
  }

  useEffect(() => {
    useEffectLoad();
    return () => {
      window.removeEventListener("message", setListener);
    }
  }, [])

  return <iframe style={{opacity: 0, visibility: "hidden", width: "1px", height: "1px", position: "absolute"}}
                 src={iframeUrl}
                 ref={ref}/>
});

const mapStateToProps = (state) => {
  const {auth, asCustomer, dashboardState} = state;
  const {job, jobEditPopupIframeLoading} = state.jobEditPopupState;
  return {
    auth,
    asCustomer,
    AR: AccessRights.get(state),
    language: dashboardState.language,
    jobEditPopupIframeLoading,
    job,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(JobEditIframe)
